import React from "react";
import { Button } from "reactstrap"; 
import { Link } from "react-router-dom";
import { useLightEdgeNotifications } from "../../hooks/useLightEdgeNotifications";
import { downloadLightEdgeNotificationAttachment } from "./utils";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

const LightEdgeNotificationItem = ({ notification, onDismiss }) => {
  const bgColor =
    notification.type === "OUTAGE"
      ? "bg-danger"
      : notification.type === "CHANGE"
      ? "bg-warning"
      : "bg-primary";

  const icon =
    notification.type === "OUTAGE"
      ? "fas fa-bolt"
      : notification.type === "CHANGE"
      ? "fas fa-exclamation"
      : "fas fa-info-circle";

  return (
    <div className="notification-item mb-3 rounded shadow-lg d-flex align-items-center bg-white border position-relative">
      <span
        className={`text-white d-flex align-items-center justify-content-center notification-icon-container ${bgColor}`}
      >
        <i className={icon} />
      </span>

      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center flex-grow-1 w-100">
        <div
          className="font-weight-bold notification-banner-mobile-text"
        >
          {notification.subject}
        </div>

        <div className="notification-actions d-flex align-items-center flex-wrap mt-1 mt-sm-0">
          {notification.hyperlink && (
            <>
              <Button
                color="link"
                size="sm"
                className="text-primary font-weight-bold p-0"
                href={notification.hyperlink}
                target="_blank"
                rel="noreferrer"
              >
                {notification.hyperlink_text}
              </Button>
              <span className="mx-1 d-none d-sm-inline">|</span>
            </>
          )}

          {notification.document && (
            <>
              <Button
                color="link"
                size="sm"
                className="text-primary font-weight-bold p-0"
                onClick={(e) =>
                  downloadLightEdgeNotificationAttachment(e, notification.document_id)
                }
              >
                {notification.document_text}
              </Button>
              <span className="mx-1 d-none d-sm-inline">|</span>
            </>
          )}

          <Button
            tag={Link}
            to={`/app/lightedge-notifications/${notification.id}`}
            color="link"
            size="sm"
            className="text-primary font-weight-bold p-0"
          >
            Details
          </Button>

          <span className="mx-1">|</span>

          <Button
            color="link"
            size="sm"
            className="text-primary p-0"
            onClick={onDismiss}
          >
            Dismiss
          </Button>
        </div>
      </div>
    </div>
  );
};

const LightEdgeNotificationList = ({ notifications, onDismiss }) => (
  <div className="notification-list-container">
    {notifications?.map((notif) => (
      <LightEdgeNotificationItem
        key={notif.id}
        notification={notif}
        onDismiss={() => onDismiss(notif.id)}
      />
    ))}
  </div>
);

const LightEdgeNotificationsBanner = () => {
  const { latestNotifications, dismissNotification, loading } =
    useLightEdgeNotifications();

  if (loading) return <LoadingSpinner />;

  return (
    <LightEdgeNotificationList
      notifications={latestNotifications}
      onDismiss={dismissNotification}
    />
  );
};

export default LightEdgeNotificationsBanner;
